export const API_BASE_URL = "https://api.heryerdeingilizce.com/api";
//export const API_BASE_URL = "https://localhost:7004/api";


export const EXPRESS_BASE_URL = "https://express.heryerdeingilizce.com";